package gr.tech.GRAttestation.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun PaginationControls(
    currentPage: Int,
    totalPages: Int,
    onPageSelected: (Int) -> Unit
) {
    Nav(
        attrs = Modifier
            .toAttrs()
    ) {
        Ul(
            attrs = Modifier
                .classNames("pagination")
                .margin(0.px)
                .toAttrs()
        ) {
            // Previous button
            Li(
                attrs = Modifier
                    .classNames("page-item")
                    .thenIf(
                        condition = currentPage <= 1,
                        other = Modifier.classNames("disabled")
                    )
                    .toAttrs()
            ) {
                A(
                    href = "#",
                    attrs = Modifier
                        .classNames("page-link")
                        .onClick {
                            it.preventDefault()
                            if (currentPage > 1) {
                                onPageSelected(currentPage - 1)
                            }
                        }
                        .toAttrs()
                ) {
                    Text("Previous")
                }
            }

            // Page numbers
            (1..totalPages).forEach { page ->
                Li(
                    attrs = Modifier
                        .classNames("page-item")
                        .thenIf(
                            condition = page == currentPage,
                            other = Modifier.classNames("active")
                        )
                        .toAttrs()
                ) {
                    A(
                        href = "#",
                        attrs = Modifier
                            .classNames("page-link")
                            .onClick {
                                it.preventDefault()
                                if (page != currentPage) {
                                    onPageSelected(page)
                                }
                            }
                            .toAttrs()
                    ) {
                        Text(page.toString())
                    }
                }
            }

            // Next button
            Li(
                attrs = Modifier
                    .classNames("page-item")
                    .thenIf(
                        condition = currentPage >= totalPages,
                        other = Modifier.classNames("disabled")
                    )
                    .toAttrs()
            ) {
                A(
                    href = "#",
                    attrs = Modifier
                        .classNames("page-link")
                        .onClick {
                            it.preventDefault()
                            if (currentPage < totalPages) {
                                onPageSelected(currentPage + 1)
                            }
                        }
                        .toAttrs()
                ) {
                    Text("Next")
                }
            }
        }
    }
}